import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TreePine, LogIn } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("hc-admin-token", res.data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Prijava ni uspela. Poskusite znova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-[#E4E0D7] p-8">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <span className="w-9 h-9 rounded-lg bg-[#2D4030] text-[#FBF9F5] flex items-center justify-center">
            <TreePine className="w-5 h-5" />
          </span>
          <span className="font-display font-extrabold text-xl">Hobby<span className="text-[#B45309]">Center</span> <span className="text-stone-400 font-medium text-sm">Admin</span></span>
        </div>
        <h1 className="font-display text-xl font-bold text-[#1A1D1A] text-center mb-6">Prijava administratorja</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-tech uppercase tracking-wider text-stone-500 block mb-1.5">E-pošta</label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@hobbycenter.si"
              className="w-full h-11 px-4 rounded-lg bg-[#FBF9F5] border border-[#E4E0D7] text-sm focus:outline-none focus:ring-2 focus:ring-[#2D4030]/30"
            />
          </div>
          <div>
            <label className="text-xs font-tech uppercase tracking-wider text-stone-500 block mb-1.5">Geslo</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full h-11 px-4 rounded-lg bg-[#FBF9F5] border border-[#E4E0D7] text-sm focus:outline-none focus:ring-2 focus:ring-[#2D4030]/30"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-full bg-[#2D4030] text-[#FBF9F5] font-semibold flex items-center justify-center gap-2 hover:bg-[#1E2C20] transition-colors disabled:opacity-60"
          >
            <LogIn className="w-4 h-4" /> {loading ? "Prijavljam …" : "Prijava"}
          </button>
        </form>
        <p className="mt-5 text-center text-xs text-stone-400">
          <Link to="/" className="hover:text-[#B45309]">← Nazaj v trgovino</Link>
        </p>
      </div>
    </div>
  );
}
